<template>
  <a
    class="block text-center active:opacity-70 desk:rounded-lg desk:text-left desk:hover:bg-gray-50"
    :href="localePath({ name: 'order-product-product', params: { product: item.no } })"
    @click.prevent="show(item)"
  >
    <div class="relative mb-1.5 aspect-square overflow-hidden rounded-lg bg-gray-50">
      <img
        v-if="index >= 0 && index < 4"
        :src="cdnImage(item.image || '/imgs/no_photo.jpg', 256)"
        :alt="item.name"
        width="256"
        height="256"
        class="w-full h-full object-contain mix-blend-multiply"
        loading="eager"
        :fetchpriority="index === 0 ? 'high' : 'auto'"
        @error="useFallbackImage"
      />
      <img
        v-else
        :src="cdnImage(item.image || '/imgs/no_photo.jpg', 256)"
        :alt="item.name"
        width="256"
        height="256"
        class="w-full h-full object-contain mix-blend-multiply"
        v-lazy-load
        loading="lazy"
        @error="useFallbackImage"
      />
    </div>
    <div v-if="hasCaption" class="px-0.5">
      <p
        class="line-clamp-2 break-all text-[10px] font-medium leading-tight text-gray-700 sm:text-[11px] desk:min-h-[42px] desk:break-normal desk:text-sm desk:leading-[21px]"
        :title="item.name"
      >
        {{ item.name }}
      </p>
      <p class="mt-1 text-[10px] font-semibold text-primary desk:mt-2 desk:text-lg" v-if="startingPrice">
        {{ currency }} {{ startingPrice | number_format }} 起
      </p>
    </div>
  </a>
</template>

<script>
import { mapActions } from "vuex";
import desktop from "@/mixins/desktop";
import { applyImageFallback } from "@/utils/desktopImages";

export default {
  mixins: [desktop],
  props: {
    item: Object,
    index: {
      type: Number,
      default: -1,
    },
    hasCaption: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions({
      fetch: "cart/fetch",
      popupShow: "popup/show",
    }),

    show(item) {
      if (this.$track) {
        this.$track.selectItem(item, {
          id:
            this.$route.query.category ||
            this.$route.query.catalog ||
            this.$route.query.keywords ||
            "all",
          name: this.$route.query.title || "全部商品",
          index: this.index,
        });
      }
      const productKey = item.id || item.no;
      if (this.isDesktop && productKey) {
        const path = this.localePath(`/order/product/${productKey}`);
        this.$router.push(path).catch(() => {
          this.openLiveSpecification(productKey);
        });
        return;
      }
      this.openLiveSpecification(productKey);
    },

    async openLiveSpecification(productKey) {
      if (!productKey) {
        return;
      }
      try {
        const { data } = await this.$axios.get("/api/products/" + productKey, {
          skipNotFoundRedirect: true,
        });
        if (data && data.data) {
          this.popupShow({
            el: "Specification",
            data: { item: data.data },
          });
        }
      } catch (e) {
        const status = e.response && e.response.status;
        if (status === 404) {
          this.dropHiddenCatalogItem(productKey);
          return;
        }
        if (status === 422) {
          this.handleErrorsMessage(e);
          return;
        }
        this.$loader.error("商品載入失敗，請稍後重試");
      }
    },

    async addToOrder() {
      if (!this.item.buyable) return false;
      if (this.isGuest()) return;
      try {
        await this.$axios.post("/api/cart", {
          product: this.item.id,
          variations: [],
          quantity: 1,
        });
        if (this.$track) {
          this.$track.addToCart(this.item, null, 1);
        }
        this.fetch();
        this.$loader.success("已加入購物車");
      } catch (e) {
        this.handleErrorsMessage(e);
      }
    },
    add() {
      if (this.item.once_for_each_only) return this.show(this.item);

      this.addToOrder();
    },
    dropHiddenCatalogItem(productKey) {
      const categories = this.$store.getters["app/categories"] || [];
      const next = categories.filter((category) => {
        return (
          String(category.id) !== String(productKey) &&
          String(category.no) !== String(productKey)
        );
      });
      if (next.length !== categories.length) {
        this.$store.commit("app/SET_CATEGORIES", next);
      }
    },
    useFallbackImage(event) {
      applyImageFallback(event, this.item.image);
    },
  },
  computed: {
    startingPrice() {
      if (!this.item.products || !this.item.products.length) return null;
      const prices = this.item.products.map((p) => Number(p.discount || p.price));
      return Math.min(...prices);
    },
  },
};
</script>

<style scoped>
.min-h-65px {
  min-height: 65px;
}
</style>
